import CollectionApi from 'client/api/v2/CollectionApi';
import SubscriptionConstants from 'client/Payments/pricingMatrix/SubscriptionConstants';
import axios from 'axios';

const { SubscriptionFields } = SubscriptionConstants;
const { listPrice } = SubscriptionFields;

const baseUrl = '/api/v2/subscriptions';
class SubscriptionApi extends CollectionApi {
  constructor() {
    super(baseUrl, {
      skip: 0,
      limit: 100,
      sort: listPrice,
    });
  }

  fetchSubscription(productCode) {
    return this.initialize()
      .then(() => axios.get(`${baseUrl}/${productCode}`)); // if no product code, will return all subscriptions
  }
}

export default new SubscriptionApi();
